import styled from "styled-components";
import {ProfileUserNameDefaultBox} from "./profile-user-name.default.box";

export const ProfileUserNameCasino777Box = styled(ProfileUserNameDefaultBox)`
    font-size: 1.4rem;
    font-weight: 700;
    ${({theme}) => theme.font.presets.bold};
`;
